import { apiClient } from './apiClient';

export interface Notification {
  notificationId: string;
  type: string;
  title: string;
  body: string;
  referenceId?: string;
  isRead: boolean;
  createdAt: number;
}

export const notificationService = {
  getNotifications: async (limit = 30) => {
    return apiClient.get<{ notifications: Notification[]; unreadCount: number }>(
      `/api/v1/notifications?limit=${limit}`
    );
  },

  getUnreadCount: async () => {
    return apiClient.get<{ count: number }>('/api/v1/notifications/unread-count');
  },

  markAsRead: async (notificationId: string) => {
    return apiClient.put<{ success: boolean }>(`/api/v1/notifications/${notificationId}/read`);
  },

  markAllAsRead: async () => {
    return apiClient.put<{ success: boolean }>('/api/v1/notifications/read-all');
  },

  delete: async (notificationId: string) => {
    return apiClient.delete<{ success: boolean }>(`/api/v1/notifications/${notificationId}`);
  },
};
